export type ActionVariant = "call" | "primary" | "outline" | "light";

const base =
  "inline-flex min-h-[52px] items-center justify-center gap-2.5 whitespace-nowrap rounded-md px-6 text-label font-bold";

const variants: Record<ActionVariant, string> = {
  call: "bg-crimson text-white hover:bg-crimson-deep",
  primary: "bg-ink text-white hover:bg-ink-deep",
  outline: "border-2 border-ink bg-white text-ink hover:bg-mist",
  light: "bg-white text-ink hover:bg-mist",
};

export function actionClass(variant: ActionVariant, extra = ""): string {
  return `${base} ${variants[variant]} ${extra}`.trim();
}
